import Handsontable from 'handsontable';

export const ON_MILANOTE_MARK_DIRTY = 'onMilanoteMarkDirty';
export const ON_MILANOTE_MARK_DIRTY_AND_FLUSH = 'onMilanoteMarkDirtyAndFlush';

let areMilanoteHotHooksRegistered = false;

/**
 * Registers Milanote-specific HOT hooks once so they are part of Handsontable's hook registry.
 */
export const registerMilanoteHotHooks = (): void => {
    if (areMilanoteHotHooksRegistered) return;

    const hooks = Handsontable.hooks;

    hooks.register(ON_MILANOTE_MARK_DIRTY);
    hooks.register(ON_MILANOTE_MARK_DIRTY_AND_FLUSH);

    areMilanoteHotHooksRegistered = true;
};
